/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "neighborhood-80137178--sprite",
  "use": "neighborhood-80137178--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"neighborhood-80137178--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"currentColor\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(-883.01 -1248.52)\"><path d=\"M895.75,1261.373v.98l-1.03.98-1.42,1.35a2.929,2.929,0,0,0-.9,2.11v1.42h-4.63a1.737,1.737,0,0,1-1.76-1.7v-5.12a1.028,1.028,0,0,1,.3-.73l4.12-3.91a.815.815,0,0,1,1.14,0v.01l3.41,3.41.48.49A1.007,1.007,0,0,1,895.75,1261.373Z\" fill=\"currentColor\" /><path d=\"M915.56,1261.373v5.14a1.744,1.744,0,0,1-1.76,1.7h-4.64v-1.44a2.951,2.951,0,0,0-.82-2.04l-.72-.71-.74-.75-1.06-1.07v-.81a.988.988,0,0,1,.3-.73l4.11-3.91a.815.815,0,0,1,1.14,0v.01l1.85,1.84,1.56,1.57.49.49A1.052,1.052,0,0,1,915.56,1261.373Z\" fill=\"currentColor\" /><path d=\"M907.66,1266.773v7.26a2.433,2.433,0,0,1-2.44,2.39h-3.31v-2.71a.8.8,0,0,0-.81-.8h-.91a.8.8,0,0,0-.81.8v2.71h-3.04a2.433,2.433,0,0,1-2.44-2.39v-7.24a1.382,1.382,0,0,1,.43-1.02l1.42-1.35,4.39-4.17a1.147,1.147,0,0,1,1.61,0,.01.01,0,0,1,.01.01l2.6,2.6,1.46,1.47.75.75.68.69A1.414,1.414,0,0,1,907.66,1266.773Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
